<template>
  <base-modal ref="modal">
    <base-card shadow>
      <div class="sm:tw-flex sm:tw-items-start">
        <div class="tw-mx-auto tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center tw-h-12 tw-w-12 tw-rounded-full tw-bg-green-100 sm:tw-mx-0 sm:tw-h-10 sm:tw-w-10">
          <check-icon class="tw-h-6 tw-w-6 tw-text-green-600" />
        </div>
        <div class="tw-mt-3 tw-text-center sm:tw-mt-0 sm:tw-ml-4 sm:tw-text-left">
          <h3 class="tw-text-xl tw-font-thin">Approve Rx Authorization</h3>
          <div class="tw-mt-2">
            <p class="tw-font-thin tw-text-gray-600">Are you sure you want to approve this Rx Authorization?</p>
          </div>
        </div>
      </div>
      <div class="sm:tw-flex sm:tw-flex-row-reverse tw-mt-4">
        <base-button @click="approveRxAuth" :loading="isLoading" class="tw-w-full sm:tw-w-auto sm:tw-ml-3" color="primary">Confirm</base-button>
        <base-button @click="hide" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0" color="gray">
          Cancel
        </base-button>
      </div>
      <inline-error id="delete-activity-modal-error" :title="errorTitle" :message="errorMessage" :error="error" />
    </base-card>
  </base-modal>
</template>

<script>
import InlineError from "@/components/InlineError";
import CheckIcon from "@/assets/svgs/check-icon.svg";

export default {
  components: {
    InlineError,
    CheckIcon,
  },
  name: "ApproveRxAuth",
  props: {
    businessId: String,
  },
  data() {
    return {
      isLoading: false,
      todoItemId: null,
      errorTitle: "",
      errorMessage: "",
      error: null,
    };
  },
  methods: {
    show(todoItemId) {
      this.todoItemId = todoItemId;
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    reset() {
      this.todoItemId = null;
    },
    approveRxAuth() {
      this.isLoading = true;

      this.$axios
        .post(`/businesses/${this.businessId}/todo/${this.todoItemId}/approve`)
        .then(() => {
          this.EventBus.$emit("GLOBAL_NOTIFY", {
            title: "Authorization Approved",
            message: `Your approval was submitted. Thank you.`,
          });
          this.EventBus.$emit("activitiesUpdated");
          this.reset();
          this.hide();
        })
        .catch((err) => {
          this.errorTitle = `Error submitting approval`;
          this.errorMessage = "Sorry, we had trouble submitting this approval. The technicians have been notified. Please try again.";
          this.error = err;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
